import $ from'jquery'

// window.onscroll = function() {myFunction()};
// var header = document.getElementById("myHeader");
// var sticky = header?.offsetTop;

// function myFunction() {
//   if (window.pageYOffset > sticky) {
//     header.classList.add("sticky");
//   } else {
//     header.classList.remove("sticky");
//   }
// }
	
	// mobile menu
	
$(document).ready(function(){$('#slide, #slide1').click(function(){var hidden=$('.sidewarper');if(hidden.hasClass('visible')){hidden.animate({"left":"-5000px"},"fast").removeClass('visible');}else{hidden.animate({"left":"0px"},"slow").addClass('visible');}});});
// mobile acordian
$(document).ready(function($){$('.accordion').find('.accordion-toggle').click(function(){$(this).next().slideToggle('fast');$(".accordion-content").not($(this).next()).slideUp('fast');});});

	